import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import demandRepository from "../services/DemandRepository";
export default class DownloadDemandDocument extends AbstractCommand {
    searchRequest;
    constructor(searchRequest) {
        super();
        this.searchRequest = searchRequest;
    }
    async execute() {
        try {
            await demandRepository.downloadDemandData(this.searchRequest);
            alerts.success(trans('demand_document.success'));
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'download_demand_document';
    }
    icon() {
        return 'file-arrow-down';
    }
    requiresPermission() {
        return 'ROLE_PERM_PORTAL_DEMAND_MANAGE';
    }
}
